import { baseUrl } from "../shared/api";

export function commentsCount(userId, type) {
  return `${baseUrl()}/api/v2/users/${userId}/comments_count?kind=${type}`;
}

export function feedback(userId) {
  return `${baseUrl()}/api/v2/users/${userId}/comments`;
}



// WEBPACK FOOTER //
// ./src/features/feedbacks/apiUrls.js